var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTeamGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.375C15.7278 9.37445 16.4457 9.54364 17.0967 9.86913C17.7477 10.1946 18.3138 10.6674 18.75 11.25",
    stroke: "#8F8C8C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 11.25C1.68625 10.6674 2.25234 10.1946 2.90331 9.86913C3.55429 9.54364 4.27219 9.37445 5 9.375",
    stroke: "#8F8C8C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.375C11.7259 14.375 13.125 12.9759 13.125 11.25C13.125 9.52411 11.7259 8.125 10 8.125C8.27411 8.125 6.875 9.52411 6.875 11.25C6.875 12.9759 8.27411 14.375 10 14.375Z",
    stroke: "#8F8C8C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 16.875C6.07366 16.1136 6.71325 15.4825 7.48054 15.0441C8.24784 14.6056 9.11627 14.375 10 14.375C10.8837 14.375 11.7522 14.6056 12.5195 15.0441C13.2867 15.4825 13.9263 16.1136 14.375 16.875",
    stroke: "#8F8C8C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5781 6.25C12.695 5.79732 12.9365 5.38648 13.2751 5.06414C13.6138 4.74181 14.036 4.5209 14.4939 4.42649C14.9518 4.33209 15.427 4.36798 15.8656 4.53009C16.3041 4.6922 16.6884 4.97403 16.9748 5.34357C17.2612 5.71311 17.4382 6.15556 17.4858 6.62067C17.5333 7.08577 17.4495 7.5549 17.2439 7.97476C17.0382 8.39462 16.7189 8.7484 16.3223 8.99592C15.9256 9.24343 15.4675 9.37476 15 9.375",
    stroke: "#8F8C8C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00069 9.375C4.53316 9.37476 4.07507 9.24343 3.67843 8.99592C3.28179 8.7484 2.96251 8.39462 2.75684 7.97476C2.55117 7.5549 2.46736 7.08577 2.51493 6.62067C2.56249 6.15556 2.73952 5.71311 3.02592 5.34357C3.31231 4.97403 3.6966 4.6922 4.13512 4.53009C4.57365 4.36798 5.04885 4.33209 5.50675 4.42649C5.96465 4.5209 6.3869 4.74181 6.72555 5.06414C7.06421 5.38648 7.30569 5.79732 7.42257 6.25",
    stroke: "#8F8C8C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeamGroup);
export default __webpack_public_path__ + "static/media/icon-team-group.280a417f1605637d76b8ae06bcea3c7b.svg";
export { ForwardRef as ReactComponent };